import {
  formatTempHour,
  TempHourType,
} from '@/pages/camel-order/temp-hour/service';
import { FormError } from '@/validate';

export type TempHourFormError = {
  tempHourDate: FormError;
};

export const validateTempHourDate = (
  error: TempHourFormError,
  tempHourType: TempHourType,
  date: Date,
  startHour: string,
  startMinute: string,
  endHour: string,
  endMinute: string
): TempHourFormError => {
  if (tempHourType === 'close') {
    return {
      ...error,
      tempHourDate: {
        ...error.tempHourDate,
        isError: false,
      },
    };
  }
  const newError = { ...error };
  newError.tempHourDate.isTouched = true;
  const startDate = formatTempHour(date, startHour, startMinute);
  const endDate = formatTempHour(date, endHour, endMinute);
  if (startDate >= endDate) {
    newError.tempHourDate.isError = true;
    newError.tempHourDate.message =
      '開始時間 < 終了時間となるように入力してください。';
    newError.tempHourDate.isError = true;
  } else {
    newError.tempHourDate.isError = false;
  }
  return newError;
};
